import { Entity } from '@backstage/catalog-model';
import { GITHUB_PROJECT_SLUG_ANNOTATION } from './platt-annotations';

export const isGitHubIssuesAvailable = (entity: Entity) => {
  return (entity?.metadata?.annotations?.[GITHUB_PROJECT_SLUG_ANNOTATION] ?? '') !== '';
}
